import { AppConfigItem } from '../models/AppConfig';
import { post } from '../utils/backend';
import { getMockData, mock } from './mock/Mock';
import './mock/AppConfigMock';

type AppConfigItemPayload = {
  id?: number | null;
  name: string;
  key: string;
  value: string;
  description: string;
};

const toPayload = (configItem: AppConfigItem): AppConfigItemPayload => ({
  id: configItem.id ? Number(configItem.id) : null,
  name: configItem.name,
  key: configItem.key,
  value: configItem.value,
  description: configItem.description,
});

const toAppConfigItem = (item: AppConfigItem & { id?: number | string }): AppConfigItem => ({
  id: item.id == null ? '' : String(item.id),
  name: item.name,
  key: item.key,
  value: item.value,
  description: item.description,
});

// 获取所有配置项
const getAllConfigs = async (): Promise<AppConfigItem[]> => {
  if (mock) return getMockData("getAllConfigs");

  const resultOrErrorCode = await post<Record<string, never>, AppConfigItem[]>("/configs/getAllConfigs", {});
  if (typeof resultOrErrorCode === 'string') {
    return [];
  }
  return (resultOrErrorCode || []).map(toAppConfigItem);
};

// 添加配置项
const addConfigItem = async (configItem: AppConfigItem): Promise<number> => {
  if (mock) return getMockData("addConfigItem");

  const resultOrErrorCode = await post<AppConfigItemPayload, number>("/configs/add", toPayload(configItem));
  if (typeof resultOrErrorCode === 'string') {
    throw new Error('添加配置项失败');
  }
  return resultOrErrorCode;
};

// 更新配置项
const updateConfigItem = async (configItem: AppConfigItem): Promise<boolean> => {
  if (mock) return getMockData("updateConfigItem");

  const resultOrErrorCode = await post<AppConfigItemPayload, boolean>("/configs/update", toPayload(configItem));
  if (typeof resultOrErrorCode === 'string') {
    return false;
  }
  return resultOrErrorCode;
};

// 删除配置项
const deleteConfigItem = async (id: string): Promise<boolean> => {
  if (mock) return getMockData("deleteConfigItem");

  const resultOrErrorCode = await post<number, boolean>("/configs/delete", Number(id));
  if (typeof resultOrErrorCode === 'string') {
    return false;
  }
  return resultOrErrorCode;
};

export const AppConfigApi = {
  getAllConfigs,
  addConfigItem,
  updateConfigItem,
  deleteConfigItem
};
